import { render } from "./message-center.vue?vue&type=template&id=27e9bb44&scoped=true"
import script from "./message-center.vue?vue&type=script&lang=js"
export * from "./message-center.vue?vue&type=script&lang=js"

import "./message-center.vue?vue&type=style&index=0&id=27e9bb44&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e9bb44"]])

export default __exports__